import { render, staticRenderFns } from "./AppUser.vue?vue&type=template&id=b446cfa2&"
import script from "./AppUser.vue?vue&type=script&lang=js&"
export * from "./AppUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports